import { call, takeEvery } from 'redux-saga/effects';

import { LookupUrls } from 'config/urls';
import { LookupConstants } from 'constants/lookupConstants';
import { request } from 'components/Request';

function* getLoanPurposes(action) {
  yield call(request({
    type: LookupConstants.GET_LOAN_PURPOSES,
    method: 'GET',
    url: LookupUrls.loanPurposes(),
  }), action);
}

const LookupSaga = function* () {
  yield takeEvery(LookupConstants.GET_LOAN_PURPOSES, getLoanPurposes);
};

export default LookupSaga;
